// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"479dda48","362":"f1071213","453":"ace21015"}[chunkId] + ".chunk.js";
};